export class EFrom {
    id: string;
    version: string;
    lastUpdate: any;
    formName: MultiLang;
    original: string;
    key: string;
    sections: Section[];
    value: any;
    docId: string;
}

export interface Section {
    index: number;
    key: string;
    name: MultiLang;
    classes: string;
    permissions: Group[];
    description: MultiLang;
    fields: Field[];
    fieldNames: any[];
    fieldIndex: any[];
}

export interface Field {
    index: number;
    labelName: MultiLang;
    label: MultiLang;
    addressLabel: AddressLabel;
    nameLabel: NameLabel;
    columns: Column[];
    fieldName: string;
    fieldType: string;
    type: string;
    key: string;
    subType: string;
    placeholder: MultiLang;
    placeholders: Placeholder;
    required: boolean;
    display: boolean;
    isRegex: boolean;
    regex: string;
    regexMessage: MultiLang;
    choiceLayout: string;
    choiceOption: string;
    choiceDefaultValue: string;
    choices: Choice[];
    choiceLookUp: ChoiceLookUp;
    range: string;
    radioOption: number;
    radioDefaultValue: string;
    decimalPlace: number;
    rangeStart: string;
    rangeEnd: string;
    currency: string;
    dateOption: number; // 0 = B.C., 1 = B.E.
    timeOption: number; // 0 = 24hrs, 1 = AM/PM
    dateFormat: number; // 0 = dd mmmm yyyy, 1 = dd mmm yyyy, 2 = dd mm yyyy, 3 = dd mm yy
    timeFormat: number; // 0 = hh:mm, 1 = hh:mm:ss, 2 = hh:mm:ss.sss
    separateDate: number; // 0 = Hyphen -, 1 = Slash /, 2 = Space
    fieldNameEmpty: string;
    address1: OptionsInclude;
    address2: OptionsInclude;
    province: OptionsInclude;
    district: OptionsInclude;
    subDistrict: OptionsInclude;
    zipCode: OptionsInclude;
    city: OptionsInclude;
    state: OptionsInclude;
    postal: OptionsInclude;
    country: OptionsInclude;
    title: OptionsInclude;
    middleName: OptionsInclude;
    initial: OptionsInclude;
    includePublicKey: boolean;
    includeSignature: boolean;
    allowType: String;
    maximumSize: number;
    maximumFile: number;
    maxLength: number;
    minItem: string;
    maxItem: string;
    typeSummary: string;
    order: number;
    // value: any;
}

export interface State {
    sectionIndex: number;
    fieldIndex: number;
    name: string;
    tableIndex: number;
    nameTable: string;
}

export interface AddressLabel {
   labelAddress1: MultiLang;
   labelAddress2: MultiLang;
   labelProvince: MultiLang;
   labelDistrict: MultiLang;
   labelSubDistrict: MultiLang;
   labelZipcode: MultiLang;
   labelPostal: MultiLang;
   labelCity: MultiLang;
   labelState: MultiLang;
   labelCountry: MultiLang;
}

export interface NameLabel {
   labelTitle: MultiLang;
   labelName: MultiLang;
   labelSurname: MultiLang;
   labelMiddle: MultiLang;
   labelInitial: MultiLang;
}

export interface Column {
   display: boolean;
   fieldName: string;
   fieldType: string;
   isRegex: boolean;
   key: string;
   labelName: MultiLang;
   maxLength: number;
   placeholder: MultiLang;
   regex: string;
   regexMessage: MultiLang;
   required: boolean;
   type: string;
   decimalPlace: number;
   rangeStart: string;
   rangeEnd: string;
   typeSummary: string;
   currency: string;
   subType: string;
   order: number;

   choiceLookUp: ChoiceLookUp;
   choices: Choice[];
   choiceLayout: string;
   choiceOption: string;
   choiceDefaultValue: string;

   radioOption: number;
   radioDefaultValue: string;

   dateOption: number; // 0 = B.C., 1 = B.E.
   timeOption: number; // 0 = 24hrs, 1 = AM/PM
   dateFormat: number; // 0 = dd mmmm yyyy, 1 = dd mmm yyyy, 2 = dd mm yyyy, 3 = dd mm yy
   timeFormat: number; // 0 = hh:mm, 1 = hh:mm:ss, 2 = hh:mm:ss.sss
   separateDate: number; // 0 = Hyphen -, 1 = Slash /, 2 = Space
}

export interface Placeholder {
   address1: MultiLang;
   address2: MultiLang;
   provice: MultiLang;
   district: MultiLang;
   subDistrict: MultiLang;
   zipcode: MultiLang;
   postal: MultiLang;
   city: MultiLang;
   state: MultiLang;
   country: MultiLang;
   title: MultiLang;
   name: MultiLang;
   surname: MultiLang;
   middle: MultiLang;
   initial: MultiLang;
}

export interface MultiLang {
   id?: number;
   th: string;
   en: string;
   cn: string;
   isPrompt?: boolean;
}

export interface OptionsInclude {
   include: boolean;
   required: boolean;
   type: number;
   customizeData: Array<MultiLang>;
   defaultValue: DefaultValue;
}

export interface DefaultValue {
   value: string;
   id: number;
   name_th: string;
   name_en: string;
   name_cn: string;
   zip_code: number;
}

export class Group {
   type: string;
   id: string;
   name: string;
   groupCode: string;
   siteCode: string;
   authority: string;
 }

 export class Choice {
    label: MultiLang;
    value: string;
 }

 export class ChoiceLookUp {
   id: string;
   tableName: string;
   columnName: string;
   isLookUp: boolean;
}

export class Hightlight {
    sectionIndex: number;
    fieldIndex: number;
    fieldSectionIndex: number;
    $event: any;
    tableIndex: number;
 }
